<template>
	<div class="parts-locations-general-card">
		<SectionContainer>
			<!-- Appointment -->
			<template #left>
				<h4>Appointment</h4>
			</template>
			<template #content>
				<!-- RO Default Advisor -->
				<dl>
					<dd>
						Appt Default Advisor
					</dd>
					<dd>
						Require Appt Advisor
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Shared Settings Section -->
		<SectionContainer>
			<template #left>
				<h4>Shared Settings</h4>
			</template>
			<template #content>
				<!-- Shared Settings -->
				<dl>
					<dd>
						<ExpandableText
							title="Auto VIS"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Default Notify By"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Multiple Dept Types"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Paint & Supply Markup"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Repair Order Default Advisor"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Repair Order Concern"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Estimate Settings -->
		<SectionContainer>
			<template #left>
				<h4>Estimate Settings</h4>
			</template>
			<template #content>
				<dl>
					<dd># of Days to Expire</dd>
					<dd>Next Estimate</dd>
				</dl>
			</template>
		</SectionContainer>
		<!-- Repair Order Settings -->
		<SectionContainer>
			<template #left>
				<h4>Repair Order Settings</h4>
			</template>
			<template #content>
				<dl>
					<dd>Attach WO on Release</dd>
					<dd>
						<ExpandableText
							title="Auto assign Actual Hours"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Auto assign Actual With"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Default Notify By"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>Edit Fixed Price Parts</dd>
					<dd>
						<ExpandableText
							title="Imported Operations Order Source"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>Next Repair Order</dd>
					<dd>
						<ExpandableText
							title="Part Request Send To"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Parts Can Recover Ops"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>Pay by Actual Hours</dd>
					<dd>Print Purchase Order Prompt</dd>
					<dd>Promise Time</dd>
					<dd>
						<ExpandableText
							title="Release Button Actions"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Require Op Codes"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Require Techician"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>Repair Order Promise Time</dd>
					<dd>Show Actual Hours</dd>
					<dd>
						<ExpandableText
							title="Sublet Prompt"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Update Mileage"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
					<dd>
						<ExpandableText
							title="Warranty & Flag Hours Validation"
							:value="'Lorem ipsum dolor'"
						/>
					</dd>
				</dl>
			</template>
		</SectionContainer>
	</div>
</template>

<script>
import SectionContainer from '@/components/shells/section-container/section-container';
import ExpandableText from '@/components/visual/expandable-text';

export default {
	name: 'PartsLocationsGeneralCard',
	components: { SectionContainer, ExpandableText }
};
</script>

<style lang="scss" scoped>
.parts-locations-general-card {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: 12px;

	&__item {
		display: block;
	}

	.section-header {
		display: inline-block;
	}
}
</style>
